<template>
  <p
    :class="[{ primary }, `text-component-align-${align}`]"
    :style="getStyleObject"
    class="text-component"
  >
    <!-- @slot Utilice este `slot` para insertar el contenido del componente -->
    <slot />
  </p>
</template>

<script>
/**
 * Componente para adicionar texto personalizado, con colores, tamaños y más, a
 * los proyectos de ALD.
 */
export default {
  name: 'AldText',
  status: 'ready',
  release: '1.1.0',

  props: {
    /**
     * Si existe el texto aparece con el color definido como `primary` en el theme
     */
    primary: {
      type: Boolean,
      default: false
    },
    /**
     * El color del contenido en HEX o nombre de color predefinido.
     */
    color: {
      type: String,
      default: '#7c7c7c'
    },
    /**
     * Número del tamaño de la fuente en `px`
     */
    fontSize: {
      type: Number,
      default: 16
    },
    /**
     * Alineado del texto. Valores permitidos `left, center, right`
     */
    align: {
      type: String,
      default: 'left',
      validator: value => value.match(/(left|center|right)/)
    }
  },

  computed: {
    getStyleObject() {
      return this.primary
        ? { fontSize: `${this.fontSize}px` }
        : { color: this.color, fontSize: `${this.fontSize}px` };
    }
  }
};
</script>

<style lang="scss" scoped src="./text.scss"></style>
